import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AircallRegularAi from './aircall-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AircallRegularAi {...validProps} />;
}
SvgComponent.iconName = 'aircallRegularAi';

export const AircallRegularAiIcon = svgIconWrapper(SvgComponent);
